import React from 'react';
import { Link } from 'react-router-dom';

function APIKeys() {
  return (
    <div className="docs-content">
      <h1>API Keys</h1>
      <p className="docs-lead">
        API keys let you call SignTada’s API from your backend, scripts, or integrations. Keys are managed only in the dashboard; there are no public API endpoints for creating or revoking keys.
      </p>

      <h2>Getting your API key</h2>
      <p>
        Log in to the dashboard and go to <strong>Settings</strong>. In the API Keys section you can view and copy your key. It is shown in a format such as <code>sk_live_…</code>. Keep it secret: anyone with the key can act on behalf of your organization within the scope of your role.
      </p>

      <h2>Using the key</h2>
      <p>
        Send the key in the <strong>X-API-Key</strong> header on every request to protected endpoints:
      </p>
      <pre><code>{'X-API-Key: sk_live_<your_key>'}</code></pre>
      <p>
        Example with cURL:
      </p>
      <pre><code>{`curl -X GET "https://api.signtada.com/requests/list_requests?page=1&per_page=10" \\
  -H "X-API-Key: sk_live_YOUR_KEY"`}</code></pre>
      <p>
        For user-based authentication (e.g. after login), you can instead send <code>Authorization: Bearer &lt;access_token&gt;</code>. The API Reference indicates which endpoints accept API key, Bearer token, or both.
      </p>

      <h2>Base URL</h2>
      <p>
        All API requests use the base URL <strong>https://api.signtada.com</strong>. Replace with your deployment URL if you self-host.
      </p>

      <h2>Security</h2>
      <p>
        Do not commit API keys to version control or expose them in client-side code. Use keys only in server-side or secure environments. If a key is compromised, revoke it in the dashboard and create a new one. Key management (create, revoke, list) is done only in the dashboard; there are no public API endpoints for key management to reduce the risk of accidental exposure.
      </p>

      <h2>Next steps</h2>
      <p>
        See the <Link to="/api-reference">API Reference</Link> for full endpoint documentation, request/response shapes, and try-it examples for Authentication, Document Requests, Templates, Webhooks, Files, Signing, Users, OTP, and Branding.
      </p>

      <p>
        <Link to="/branding">← Branding</Link> · <Link to="/api-reference">API Reference →</Link>
      </p>
    </div>
  );
}

export default APIKeys;
